import Helpers from 'utils/helpers';

function modifyClonedProps(props, clonedProps) {
  const hasChangeHandler = Helpers.Object.exists(props.onChange) || Helpers.Object.exists(props.onValueChange);
  const hasValue = Helpers.Object.exists(props.value);
  if (hasChangeHandler && hasValue) {
    //use controlled
    delete clonedProps.defaultValue;
  }
  else if (!hasChangeHandler && hasValue) {
    //use uncontrolled, swap value info defaultValue
    clonedProps.defaultValue = props.value;
    delete clonedProps.value;
  }
  else if (hasChangeHandler && !hasValue) {
    //use controlled, swap defaultValue into value
    clonedProps.value = clonedProps.defaultValue || '';
    delete clonedProps.defaultValue;
  }
  else {
    //use uncontrolled
    clonedProps.defaultValue = clonedProps.defaultValue || '';
    delete clonedProps.onChange;
    delete clonedProps.value;
  }

  //make sure values are never null, replace with empty string instead
  if (clonedProps.value === null) {
    clonedProps.value = '';
  }
  if (clonedProps.defaultValue === null) {
    clonedProps.defaultValue = '';
  }
}

function isControlled(props) {
  return !Helpers.Object.exists(props.defaultValue);
}



const InputHelpers = {
  modifyClonedProps,
  isControlled,
};

export default InputHelpers;